
import { supabase } from '@/integrations/supabase/client';
import LoggingService from '@/services/LoggingService';

export interface ConnectionTestResult {
  success: boolean;
  error?: string;
  data?: any;
  details?: any;
}

export default class ConnectionServiceBase {
  protected logSource: string = 'ConnectionService';
  protected supabase = supabase;
  
  protected constructor() {}
  
  protected async requestAccessToken(url: string, payload: Record<string, string>): Promise<{ success: boolean; token?: string; error?: string }> {
    try {
      this.logDebug('Requesting access token', { url, ...payload });
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(payload)
      });
      
      const data = await response.json();
      
      if (!response.ok || !data.access_token) {
        this.logError('Failed to obtain access token', data);
        return { 
          success: false, 
          error: data.error_description || 'Failed to obtain access token' 
        };
      }
      
      this.logDebug('Access token obtained successfully');
      return { success: true, token: data.access_token };
    } catch (error: any) {
      this.logError('Error requesting access token', error);
      return { 
        success: false, 
        error: error.message || 'Unknown error obtaining access token' 
      };
    }
  }
  
  protected logDebug(message: string, data?: any) {
    LoggingService.debug(message, data || {}, this.logSource);
  }
  
  protected logInfo(message: string, data?: any) {
    LoggingService.info(message, data || {}, this.logSource);
  }
  
  protected logWarn(message: string, data?: any) {
    LoggingService.warn(message, data || {}, this.logSource);
  }
  
  protected logError(message: string, error: any) {
    LoggingService.error(message, error, this.logSource);
  }
}
